export const useGoogleMapsApi = () => {
  const maps = ref<typeof google.maps>();
  const config = useRuntimeConfig();
  const {onLoaded} = useScriptGoogleMaps({
    apiKey: config.public.googleApiKey,
  });
  onMounted(() => {
    onLoaded(async (instance) => {
      maps.value = (await instance.maps) as any as typeof google.maps;
    });
  });
  return {maps};
};
